import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/19th_Century_-_Meiji_Restoration_Japan.png';

function HistoryPageMeijiRestoration() {
  return (
    <TopicPage
      topicKey="Meiji Restoration (Japan)"
      title="History: Meiji Restoration"
      backgroundImage={bg}
      startRoute="/History-Meiji-Restoration-Go"
      scrollLabels={[
        "End of the Tokugawa Shogunate",
        "Modernization and Industrialization",
        "Social and Political Reforms",
      ]}
      backRoute="/history-19th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageMeijiRestoration;
